import * as React from 'react'
import ModernNavbar from '../setup/ModernNavbar'
import { Container, Grid2, Typography, Box } from '@mui/material'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import TableDataWithPagination from '../../BuiltInComponent/TableWithPagination'
import DateTimePicker from '../../BuiltInComponent/DateTimePicker'
import BasicSwitches from '../../BuiltInComponent/SwitchButton'
import Loading from '../../BuiltInComponent/Loading'
import HeadingText from '../../BuiltInComponent/HeadingTest'
import ButtonNormal from '../../BuiltInComponent/ButtonNormal'
import AutoComplete from '../../BuiltInComponent/AutoComplete'
import { useNavigate } from 'react-router-dom'
import Footer from '../setup/Footer'
import dayjs from 'dayjs'
import AttendanceReportPDF from '../PayrollReports/AttendanceReportPDF'
import { useDispatch, useSelector } from 'react-redux'
import { getDailyAttendance } from '../../features/PayrollManagement/attendanceSlice'
import { getDepartments } from '../../features/AdminManagement/departmentSlice'
import { getUnits } from '../../features/AdminManagement/unitsSlice'


export default function CurrentDayAttendance() {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { dateWiseAtt, isLoading } = useSelector(state => state.att)

    const { departments } = useSelector((state) => state.dept);
    const { units } = useSelector((state) => state.units);

    const [selectedDate, setSelectedDate] = React.useState(dayjs());
    const [switchStatus, setSwitchStatus] = React.useState(true);
    const [filterStatus, setFilterStatus] = React.useState(false);
    const [rptFilter, setRptFilter] = React.useState({
        fromDate: null,
        toDate: null,
        department: null,
        unit: null,
    })

    React.useEffect(() => {
        dispatch(getDailyAttendance({ procOrder: 'Get Att Date Wise Pr', targetDate: dayjs(selectedDate.$d).format('YYYY-MM-DD'), empID: null, fromDate: null, toDate: null, department: null, unit: null }))
    }, [selectedDate, dispatch])

    React.useEffect(() => {
        dispatch(getDailyAttendance({ procOrder: `Get Att Date Wise Pr`, targetDate: dayjs(new Date()).format('YYYY-MM-DD'), empID: null, fromDate: null, toDate: null, department: null, unit: null }))
    }, [dispatch])

    React.useEffect(() => {
        dispatch(getDepartments())
        dispatch(getUnits())
    }, [dispatch])

    const tableColumns = [
        { fieldName: 'empID', cName: 'Emp Pic', textAlign: 'left', width: 80, dType: 'img', status: 'en' },
        { fieldName: 'empImage', cName: 'Emp Pic', textAlign: 'left', width: 80, dType: 'img', status: 'en' },
        { fieldName: 'empName', cName: 'Emp Name', textAlign: 'left', width: '5%', dType: 'string', status: 'en' },
        { fieldName: 'unitDescription', cName: 'Unit', textAlign: 'left', width: 80, dType: 'string', status: 'en' },
        { fieldName: 'deptName', cName: 'Dept', textAlign: 'left', width: 80, dType: 'string', status: 'en' },
        { fieldName: 'shiftName', cName: 'Shift', textAlign: 'left', width: 80, dType: 'string', status: 'en' },
        { fieldName: 'time_in', cName: 'Time In', textAlign: 'left', width: 80, dType: 'string', status: 'en' },
        { fieldName: 'time_out', cName: 'Time Out', textAlign: 'left', width: 80, dType: 'string', status: 'en' },
        { fieldName: 'late_in_status', cName: 'Late Status', textAlign: 'left', width: 80, dType: 'string', status: 'en' },
        { fieldName: 'early_out_status', cName: 'Early Gone', textAlign: 'center', width: 80, dType: 'string', status: 'en' },
        { fieldName: 'late_minutes', cName: 'In Time Short Excess', textAlign: 'center', width: 100, dType: 'string', status: 'en' },
        { fieldName: 'overtime_minutes', cName: 'Out Time Short Excess', textAlign: 'center', width: 100, dType: 'string', status: 'en' },
        { fieldName: 'net_overtime_minutes', cName: 'Adjustments', textAlign: 'center', width: 80, dType: 'string', status: 'en' },
        { fieldName: 'edit', cName: 'Edit', textAlign: 'center', width: '20%', status: 'dis' },
        { fieldName: 'print', cName: 'Print', textAlign: 'center', width: '20%', status: 'dis' },
        { fieldName: 'print', cName: 'Print', textAlign: 'center', width: 500, status: 'en', buttonText: `Individual` },
    ]

    const onEditClick = (id) => {
        console.log(id)
    }

    const onPrintClick = (empID) => {
        navigate('/IndividualAttSheet', { state: { empID: empID, targetDate: dayjs(selectedDate.$d).format('YYYY-MM-DD') } })
    }

    const handleDateChange = (newDate) => {
        setSelectedDate(newDate)
        setSwitchStatus(true)
    };

    const handleSwitchButton = async (e) => {
        setSwitchStatus(e)
        dispatch(getDailyAttendance({ procOrder: `Get Att Date Wise ${e ? 'Pr' : 'Ab'}`, targetDate: dayjs(selectedDate.$d).format('YYYY-MM-DD'), empID: null, fromDate: null, toDate: null, department: null, unit: null }))
    }

    const handleDeptChange = (data) => {
        if (data !== null) {
            const keys = Object.keys(data)
            if (keys[0] === 'deptID') {
                setRptFilter(prev => ({ ...prev, department: data[keys] }))
            }
            if (keys[0] === 'unitID') {
                setRptFilter(prev => ({ ...prev, unit: data[keys] }))
            }
        }
    }

    const handleApplyButton = () => {
        const fromDate = filterStatus.fromDate ? dayjs(filterStatus.fromDate.$d).format('YYYY-MM-DD') : null
        const toDate = filterStatus.toDate ? dayjs(filterStatus.toDate.$d).format('YYYY-MM-DD') : null
        const department = rptFilter.department ? rptFilter.department : null
        const unit = rptFilter.unit ? rptFilter.unit : null
        console.log({ fromDate, toDate, department, unit })
        dispatch(getDailyAttendance({
            procOrder: `Get Group Att`,
            targetDate: dayjs(selectedDate.$d).format('YYYY-MM-DD'),
            empID: null,
            fromDate, toDate, department, unit
        }))
    }
    // 'Get Group Att', null, null, null, null,'2025-10-07','2025-10-15', null, null
    return (
        <>
            <ModernNavbar />
            <Container sx={{ mt: 10 }}>

                <Grid2 container spacing={2}>
                    <Grid2 size={3}>
                        <DateTimePicker
                            label='Present Date'
                            value={selectedDate}
                            onChange={handleDateChange}
                        />
                    </Grid2>
                    <Grid2 size={6}>
                        <HeadingText text={`${switchStatus ? 'Present' : 'Absent'} Sheet`} />
                    </Grid2>
                    <Grid2 size={3}>
                        <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
                            {isLoading ? <Loading /> : !filterStatus ? <AttendanceReportPDF
                                data={dateWiseAtt && dateWiseAtt}
                                title="Daily Attendance Report"
                                company="Maltex Exports"
                                fileName={`Attendance Report For ${dayjs(selectedDate).format('DD-MMM-YYYY')}`}
                                reportDate={dayjs(selectedDate).format('DD-MMM-YYYY')}
                                label="Print Report" /> : <></>
                            }
                        </Box>
                    </Grid2>
                    <Grid2 size={8}>
                        <Typography sx={{ fontWeight: 'bold', display: `${!filterStatus ? '' : 'none'}` }}>{switchStatus ? `Total Present ${dateWiseAtt && dateWiseAtt.length}` : `Total Absent ${dateWiseAtt && dateWiseAtt.length}`}</Typography>
                    </Grid2>
                    <Grid2 size={4} >
                        <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
                            <Typography sx={{ fontWeight: 'bold' }}>{switchStatus ? 'Present' : 'Absent'}</Typography>
                            <BasicSwitches
                                label="Present / Absent"
                                status={switchStatus}
                                funcOnChange={handleSwitchButton}
                            />
                        </Box>
                    </Grid2>
                    <Grid2 size={12}>
                        {filterStatus ? <>
                            <FilterAltOffIcon
                                sx={{
                                    fontSize: 30, color: 'white', cursor: 'pointer',
                                    backgroundColor: '#1E90FF', padding: 1, borderRadius: 2, marginBottom: 1
                                }}
                                onClick={() => { setFilterStatus(!filterStatus) }}

                            />
                        </> :
                            <>
                                <FilterAltIcon
                                    sx={{
                                        fontSize: 30, color: 'white', cursor: 'pointer',
                                        backgroundColor: '#1E90FF', padding: 1, borderRadius: 2, marginBottom: 1
                                    }}
                                    onClick={() => {
                                        setFilterStatus(!filterStatus)
                                        dispatch(getDailyAttendance({ procOrder: 'Get Att Date Wise Pr', targetDate: dayjs(selectedDate.$d).format('YYYY-MM-DD'), empID: null, fromDate: null, toDate: null, department: null, unit: null }))
                                    }}

                                />
                            </>}
                    </Grid2>
                    <Grid2 size={2} sx={{ display: `${filterStatus ? '' : 'none'}`, mb: 2 }}>
                        <DateTimePicker
                            label='Present Date'
                            value={filterStatus.fromDate}
                            onChange={(newDate) => { setFilterStatus(prev => ({ ...prev, fromDate: newDate })) }}
                        />
                    </Grid2>
                    <Grid2 size={2} sx={{ display: `${filterStatus ? '' : 'none'}`, mb: 2 }}>
                        <DateTimePicker
                            label='Present Date'
                            value={filterStatus.toDate}
                            onChange={(newDate) => { setFilterStatus(prev => ({ ...prev, toDate: newDate })) }}
                        />
                    </Grid2>
                    <Grid2 size={3} sx={{ display: `${filterStatus ? '' : 'none'}`, mb: 2 }}>
                        <AutoComplete
                            listData={departments}
                            columnName={'deptDesc'}
                            label={'Department'}
                            value={departments.find((c) => c.deptID === rptFilter.department)}
                            // value={emp.deptDesc}
                            onChange={handleDeptChange}
                        />
                    </Grid2>
                    <Grid2 size={3} sx={{ display: `${filterStatus ? '' : 'none'}`, mb: 2 }}>
                        <AutoComplete
                            listData={units}
                            columnName={'unitID'}
                            label={'Units'}
                            value={units.find((c) => c.unitID === rptFilter.unit)}
                            // value={emp.deptDesc}
                            onChange={handleDeptChange}
                        />
                    </Grid2>
                    <Grid2 size={2} sx={{ display: `${filterStatus ? '' : 'none'}`, mb: 1 }}>
                        <ButtonNormal text={'Apply'} onClick={handleApplyButton} />
                    </Grid2>
                </Grid2>
            </Container>
            {
                isLoading ?
                    <>
                        <Loading />
                    </>
                    :
                    dateWiseAtt.length > 0 ?
                        <>
                            <Box style={{ marginLeft: 20, marginRight: 20 }}>
                                <TableDataWithPagination tableColumns={tableColumns} tableData={dateWiseAtt && dateWiseAtt}
                                    onEditClick={onEditClick} onButtonClick={onPrintClick} perPage={50} />
                            </Box>
                        </>
                        : <><HeadingText text="Data Not Found!..." /></>
            }
            <Footer />
        </>
    )
}

